export const de = {
  translation: {
    learn: {
      chapterNote: {
        summaryTooltip: 'Zusammenfassung',
        exerciseDisabledTooltip:
          'In Übungen bieten wir keine Notizen an, um zu vermeiden, dass du dir selbst Lösungshinweise notierst.',
      },
    },
    test: {
      menu: {
        contents: 'Testinhalte',
        courseContents: 'Kursinhalte',
        results: 'Testergebnisse',
        runs: 'Testruns',
        hint: 'Test-Funktionen findest Du hier: Status, Testruns, Timer und Ergebnisse.',
      },
      summary: {
        title: 'Letzte Testauswertung',
        overall: 'Gesamter Test',
        weakestSection: 'Schwächster Bereich',
        score: '{{correct}} richtig · {{points}} Punkte · {{percentage}} %',
        viewResults: 'Ergebnisse ansehen',
      },
      results: {
        latestEvaluation: 'Letzte Auswertung',
        runLabel: 'Testrun {{run}} · {{date}}',
        runTab: 'Testrun {{run}}',
      },
      percentageRanking: {
        zeroCorrect:
          'Für die Berechnung Deines Prozentrangs benötigst Du mindestens eine vollständig richtig beantwortete Frage. Sobald Du eine Frage korrekt beantwortet hast, wird Dein Prozentrang berechnet.',
      },
      insight: {
        title: 'Dein Ergebnis',
        scoreLine: '{{correct}} von {{questions}} Fragen richtig · {{percentage}} %',
        coaching: {
          firstRun:
            'Dein erster Testrun ist abgeschlossen. Nutze die Auswertung, um gezielt an Deinen Schwachstellen zu arbeiten — jeder weitere Testrun bringt Dich näher an Dein Ziel.',
          improved:
            'Starke Entwicklung: Du hast Dich um {{delta}} Prozentpunkte verbessert (aktuell {{percentage}} %). Bleib dran und vertiefe die Bereiche, die noch Potenzial haben.',
          steady:
            'Dein Ergebnis liegt stabil bei {{percentage}} %. Konzentriere Dich auf gezieltes Üben in Deinen schwächsten Bereichen, um den nächsten Sprung zu schaffen.',
          declined:
            'Dieser Testrun liegt {{delta}} Prozentpunkte unter dem vorherigen. Das ist normal beim Lernen — schau Dir die Lösungen an und starte den nächsten Testrun mit einem klaren Fokus.',
        },
        trend: {
          title: 'Dein Fortschritt',
          subtitle: 'Entwicklung Deiner zutreffenden Quote über alle Testruns',
          seriesLabel: 'Zutreffende Quote',
          deltaUp: '{{delta}} % zum letzten Testrun',
          deltaDown: '{{delta}} % zum letzten Testrun',
        },
        sections: {
          title: 'Stärken & Schwächen',
          subtitle:
            'Deine Leistung pro Prüfungsbereich im aktuellen Zeitfenster (bis zum letzten Test)',
          correct: 'Richtig {{count}}',
          marked: 'Markiert {{count}}',
          total: 'Gesamt {{count}}',
          percentile: 'PR {{pr}}',
          insufficientData: 'Noch nicht genügend Ergebnisse für einen Prozentrang',
        },
        goal: {
          title: 'Dein Ziel',
          explanationTitle: 'Was bedeutet der Prozentrang?',
          explanation:
            'Mit Deinem <strong>Ergebnis von {{points}} Punkten</strong> hast Du einen <strong>Prozentrang (PR) von {{pr}}</strong> erreicht. Das bedeutet, dass Dein Testergebnis besser oder gleich gut wie das von {{pr}} % aller Testläufe im aktuellen Zeitfenster ist. Im Folgenden kannst Du einsehen, ob <strong>Dein Testergebnis im aktuellen Zeitfenster</strong> für eine Studienplatzzusage ausreichend gewesen wäre:',
          zeroCorrect:
            'Beantworte mindestens eine Frage richtig, um Deinen Prozentrang zu berechnen. Für {{city}} wären {{target}} PR nötig.',
          yourPr: 'Dein Prozentrang: {{pr}} PR',
          runPrFlag: 'Testrun {{run}}: {{pr}} PR',
          metBadge: 'ausreichend',
          unmetBadge: 'nicht ausreichend',
        },
        nextSteps: {
          title: 'Was kommt als Nächstes?',
          subtitle: 'Konzentriere Dich auf diese Bereiche für den größten Lerneffekt',
          priority: 'Priorität {{rank}}',
          sectionScore: 'Aktuell {{percentage}} % zutreffend',
          strategy:
            'Schau Dir die Lösungen und Erklärungen an. Notiere Muster in den Fragen, bei denen Du unsicher warst.',
          reviewSection: '{{label}} durchgehen',
          open: 'Öffnen',
        },
      },
    },
    flashcard: {
      common: {
        card_one: 'Karte',
        card_other: 'Karten',
        day_one: 'Tag',
        day_other: 'Tage',
      },
      tab: {
        beta: 'Beta',
        infoTitle: 'Karteikarten',
        infoBody1:
          'Wir freuen uns, Dir unser neues Karteikarten Feature ohne Aufpreis vorstellen zu dürfen. Aktuell testen wir noch alle Funktionen und freuen uns über Dein Feedback unter',
        infoBody2:
          'Das Karteikarten System nutzt den neusten Spaced Repetition Algorithmus FSRS-5 und schlägt Dir automatisch jeden Tag neue und zu wiederholende Karten vor. Schaue regelmäßig vorbei für den größten Lernerfolg.',
        planningMissingPrefix: 'Definiere erst',
        planningMissingLink: 'Dein Lernende',
        planningMissingSuffix: ', um Deinen Lernprozess ideal abzustimmen.',
        freeTrialPrefix: 'Teste Karteikarten Decks mit',
        freeTrialChip: 'kostenlos',
        freeTrialSuffix: 'ohne Kauf. Um alle Decks nutzen zu können, kaufe den Kurs.',
        listAria: 'Karteikarten Deck Liste',
        loadError: 'Decks konnten nicht geladen werden.',
      },
      deckItem: {
        freeChip: 'kostenlos',
        startNow: 'Jetzt beginnen',
      },
      deckStats: {
        tooltipNew: '{{count}} neue {{cards}} in diesem Deck',
        chipNew: 'Neu: {{count}}',
        tooltipLearning: 'Heute sind {{count}} {{cards}} in der Lernphase',
        chipLearning: 'Lernen: {{count}}',
        tooltipReview: 'Heute sind {{count}} gelernte {{cards}} auf Wiedervorlage',
        chipReview: 'Wiederh.: {{count}}',
        chipAllDecksToday: 'Heute neu alle Decks: {{done}}/{{total}}',
      },
      stats: {
        overviewTitle: 'Karteikartenüberblick',
        planTitle: 'Dein Lernplan',
        toTest: 'Zum Test:',
        days: 'Tage',
        toPlannedFinish: 'Zum festgelegten Lernende:',
        tooltipPlan:
          'Das Minimum beträgt 10 Karten / Tag. Das Maximum richtet sich nach Deinem Lernende.',
        planLabel: 'Pensum zum Lernende',
        perDay: '{{count}} {{cards}} / Tag',
        totalProgress: 'Gesamtfortschritt (alle Decks):',
        allCards: 'Alle Karteikarten:',
        learned: 'Bereits gelernt:',
        notLearned: 'Noch nicht gelernt:',
        todayProgress: 'Lernfortschritt für heute',
        newLearnedToday: 'Neue Karten gelernt:',
        newLearnedTodayOpen: '{{done}} / {{total}} {{cards}}',
        newLearnedTodayDone: '🎉 {{done}} / {{total}} {{cards}}',
        toReview: 'Karten noch zu wiederholen:',
        noneOpen: '🎉 Keine offen',
      },
      flashcard: {
        loading: 'Karteikarte wird geladen...',
        question: 'Frage',
        answer: 'Antwort',
        showAnswer: 'Antwort zeigen',
        ratingTooltips: {
          again: 'Inhalt wurde vergessen',
          hard: 'Lange Zeit zum Erinnern oder leicht daneben',
          good: 'Normal erinnert',
          easy: 'Sicher und schnell erinnert',
        },
        ratings: {
          again: 'Nochmal',
          hard: 'Schwer',
          good: 'Gut',
          easy: 'Einfach',
        },
        help: {
          title: 'Hilfe und Hintergrund',
          procedureTitle: 'Vorgehensweise:',
          procedureText:
            'Lies die Frage durch und versuche Dich frei zu erinnern. Lasse Dir dann die Antwort anzeigen und bewerte die Schwierigkeit der Wiedergabe der korrekten Antwort. Basierend auf deiner Bewertung wird Dir der Inhalt im bestmöglichen Abstand für Deinen Lernerfolg erneut präsentiert.',
          backgroundTitle: 'Hintergrund:',
          backgroundText:
            'Das Karteikarten System nutzt (im Gegensatz zu Anki) den neusten Spaced Repetition Algorithmus FSRS-5 und schlägt Dir automatisch jeden Tag zu lernende Karten vor. Schaue regelmäßig vorbei für den größten Lernerfolg.',
        },
        bottomBar: {
          end: 'Beenden',
        },
      },
    },
  },
};
